import { UiBlockModel } from "../../models";

export function mockUiBlockModel({
    id = "block-1234",
    type = "uiBlock",
    locale = "en",
    content = mockUiBlockModelContent()
}: Partial<UiBlockModel> = {}): UiBlockModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiBlockModelContent = UiBlockModel["content"];

export function mockUiBlockModelContent({
    title = "Lorem Ipsum",
    ...optionals
}: Partial<UiBlockModelContent> = {}): UiBlockModelContent {
    return {
        title,
        ...optionals
    };
}
